enum ProgressCircularSize {
  SM = "sm",
  MD = "md",
  LG = "lg",
  XXL = "xxl",
}
enum ProgressCircularIconSize {
  SM = 24,
  MD = 32,
  LG = 48,
  XXL = 160,
}
enum ProgressCircularRadius {
  SM = 10.5,
  MD = 14.5,
  LG = 22,
  XXL = 76,
}
enum ProgressCircularType {
  PROGRESS = "progress",
  ERROR = "error",
  SUCCESS = "success",
}

enum ProgressCircularStokeWidth {
  XS = 2,
  XXL = 8,
}

export {
  ProgressCircularSize,
  ProgressCircularIconSize,
  ProgressCircularRadius,
  ProgressCircularType,
  ProgressCircularStokeWidth,
};
